import merge from "lodash/merge";

import * as types from "../constants/action-types";

const initialState = {
  accessToken: null,
  gaClientId: null,
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_ACCESS_TOKEN: {
      const { accessToken } = action;

      return {
        ...state,
        accessToken,
      };
    }

    case types.RECEIVE_GA_CLIENT_ID: {
      const { gaClientId } = action;

      return merge({}, state, {
        gaClientId,
      });
    }

    case types.RESET_ENV:
      return merge({}, state, initialState);

    default:
      return state;
  }
}
